let currentPricePackage = null;

class PricePackage {
    getPriceFunc
    timeoutId
    getPricePromiseResolvers = {}

    constructor(getPriceFunc) {
        this.getPriceFunc = getPriceFunc;
    }

    async getPrice(offerId) {
        return new Promise((resolve) => {
            this.getPricePromiseResolvers[offerId] = resolve;

            clearTimeout(this.timeoutId);

            this.timeoutId = setTimeout(async () => {
                currentPricePackage = null;
                try {
                    const result = await this.getPriceFunc(Object.keys(this.getPricePromiseResolvers));
                    result.forEach((resultItem) => {
                        const resolver = this.getPricePromiseResolvers[resultItem.productId];
                        if (resolver) {
                            resolver(resultItem);
                        }
                    });
                } catch (error) {
                    console.error('Failed to fetch getPrice', error);
                }
            });
        });
    }
}

export default async function useOfferGetPriceController(offerId, getPriceFunc) {
    if (!currentPricePackage) {
        currentPricePackage = new PricePackage(getPriceFunc);
    }

    return currentPricePackage.getPrice(offerId);
}
